<script setup>
import { onMounted   } from 'vue';
import Home from './view/Home.vue'

// onCreated (()=>{
  const checkIfMobile = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      return true;
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return true;
    }
  };
  console.log('created')
  if(checkIfMobile()){
    window.location.replace('http://www.perrys.co.jp/h5/');
    // window.location.href = 'http://www.perrys.co.jp/h5/';
  }
// })
onMounted(()=>{

window.onresize = () => {
  let width = document.body.clientWidth;
  if(width<=750){
    window.location.href = 'http://www.perrys.co.jp/h5/';
  }else{
    window.location.href = 'http://www.perrys.co.jp/'
  }

}
  
  console.log('mounted')
})
</script>

<template>
  <Home />
</template>

<style scoped>

</style>
